import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_dashboard/lender/applications/")({
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["applications.view_application"])) {
      throw redirect({ to: "/" })
    }
    throw redirect({ to: "/lender/applications/list" })
  },
})
